import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyMijnVerhuisTypesStore from "./property-mijn-verhuis-types.store";

const mijnVerhuisActions: ActionTree<IPropertyEditState, {}> = <ActionTree<IPropertyEditState, {}>>{
  [propertyMijnVerhuisTypesStore.Get.PUBLISH_MIJN_VERHUIS]: ({ getters, commit }, param: number) => {
    return getters.service['getPublishMijnVerhuis'](param)
      .then((data) => {
        commit(propertyMijnVerhuisTypesStore.Set.MIJNVERHUIS_REQUEST_INFO, data);
        commit(propertyMijnVerhuisTypesStore.Set.MIJNVERHUIS_ASSIGN_VALUE, { PropertyId: param });
        if (data.ContactInfos[0]) {
          commit(propertyMijnVerhuisTypesStore.Set.PRIMARY_CONTACT_ASSIGNVALUE, { ...data.ContactInfos[0] });
        } else {
          commit(propertyMijnVerhuisTypesStore.Set.PRIMARY_CONTACT_RESET);
        }
        commit(propertyMijnVerhuisTypesStore.Set.SECONDART_CONTACT_RESET);
        commit(propertyMijnVerhuisTypesStore.Set.LEAVING_CUSTOMER_RESET);
        commit(propertyMijnVerhuisTypesStore.Set.CONNECTION_RESET);
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  },
  publishMijnverHuis: ({ getters, commit }) => {
    if (getters.SecondaryContact && !getters.SecondaryContact.Id) {
      commit(propertyMijnVerhuisTypesStore.Set.MIJNVERHUIS_ASSIGN_VALUE, { SecondaryContact: null });
    }
    if (getters.LeavingCustomer && !getters.LeavingCustomer.Id) {
      commit(propertyMijnVerhuisTypesStore.Set.MIJNVERHUIS_ASSIGN_VALUE, { LeavingCustomer: null });
    }
    return getters.service['publishMijnVerhuis'](getters.mijnverhuis)
      .then((data) => { 
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  }
}

export default mijnVerhuisActions;